<ng-template #afterTitleResidualPercent>
    <app-switch-input id="residualPercentActiveOnly" [form]="form" label="common.fields.activeOnly"></app-switch-input>
</ng-template>

<app-table
    #residualPercentTable
    [afterTitle]="afterTitleResidualPercent"
    [tableTitle]="prefix + 'label'"
    [translatePrefix]="prefix"
    [gridData]="store.data.getSocialServiceResidualPercents()"
    [additionalFilter]="additionalFilter()"
    [refreshCallback]="store.api.getSocialServiceResidualPercents"
    [refreshCallbackFragment]="getSocialServiceResidualPercentsFrag"
    [columns]="columns"
    [showClearFilter]="true"
    [hideCheckboxes]="true"
    (detailCallback)="openDetail($event)"
    (createCallback)="openDetail()"
    (deleteCallbackWithEvent)="delete($event)"
>
    <ng-template pTemplate="percent" let-data="data">
        {{ data }} %
    </ng-template>
</app-table>
